import React from "react";
import { Button } from "react-bootstrap";
import Icon from './Icon';
import { Link } from 'react-router-dom';

const AssistantSingleCard = ({ data, heading }) => {

  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(w => w.charAt(0)).join('').toUpperCase().substring(0,2);
  };

  const phone = data?.assistantPhone;
  const email = data?.assistantEmail;

  return (
    <div className="p-24 rounded-16 app-shadow-sm bg-brand-light mb-24 card-managers">
      <div className="mb-16">
        <div className="d-flex align-items-center mb-12 header">
          <div className="avatar-pill me-7"><span className="text-12 fw-700 text-navy">{getInitials(heading)}</span></div>
          <h6 className="text-16 fw-700 text-navy mb-0">{heading}</h6>
        </div>
        <div className="d-flex align-items-center contact-item">
          {phone && (
            <>
              <a href={`tel:${phone}`}>
                <div className="d-flex align-items-center contact-item">
                  <img src="/assets/icons/phone.svg" alt="Phone" className="me-6" width="14" height="13" />
                  <span className="text-14 fw-500 text-navy">{phone}</span>
                </div>
              </a>
              <span className="mx-3"></span>
              </>
          )}
          <a href={`mailto:${email}`}>
            <div className="d-flex align-items-center contact-item">
              <img src="/assets/icons/email.svg" alt="Email" className="me-6" width="14" height="14" />
              <span className="text-14 fw-500 text-navy">{email}</span>
            </div>
          </a>
        </div>
      </div>

    </div>
  );
};

export default AssistantSingleCard;
